import { useQuery } from "react-query";
import { getAttributesByGroup } from "../../../components/attributes/lib/attribute-data";

export const useAttributeGroups = (groupNames, param = {}) => {
    return useQuery({
        queryKey: ["attributes", groupNames, param],
        initialData: [],
        queryFn: async () => {
            const promises = groupNames.map((groupName) => getAttributesByGroup(groupName, param));

            return Promise.all(promises).then((attributeGroups) => {
                return attributeGroups.reduce((groups, attributes) => {
                    return groups.concat(attributes);
                }, []);
            });
        },
        enabled: Array.isArray(groupNames) && groupNames.length > 0,
    });
};
